module.exports = __webpack_public_path__ + "img/00.2f7adbb2.png";